const styles = {
  group: {
    display: 'flex',
    flexDirection: 'column',
    // borderRadius: '5px',
    fontSize: '14px',
    // maxWidth: '170px',
    marginBottom: '10px',
    width: 'calc(25% - 8px)',
    padding: '10px',
    gap: '5px',
    boxShadow: '#7F1431 8px 8px 0px -3px',
    border: '1px solid #7F1431',
  },
  groupnamerow: {
    display: 'flex',
    justifyContent: 'center',
    // borderBottom: '1px solid lightgray',
    padding: '10px',
    marginBottom: '5px',
    fontWeight: '600',
    backgroundColor: '#efefef',
  },
  groupname: {
    fontSize: '16px',
    textAlign: 'center',
    textTransform: 'uppercase',
    cursor: 'pointer',
  },
  groupinfo: {
    backgroundColor: '#7F1431',
    height: '20px',
    width: '20px',
    borderRadius: '100%',
    textAlign: 'center',
    color: 'white',
    // textDecoration: 'underline solid gray',
    cursor: 'pointer',
    margin: '0 0 0 10px',
    fontWeight: '100',
  },
  row: {
    // borderRadius: '20px',
    border: '1px solid #ededed',
    // display: 'flex',
    alignItems: 'center',
    // margin: '3px',
    padding: '5px',
    width: '60%',
    margin: '0 auto',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#ededed',
    },
  },
  row_firstpicked: {
    composes: ['$row'],
    border: '1px solid #62AD1D',
  },
  row_secondpicked: {
    composes: ['$row'],
    border: '1px solid #F9981D',
  },
  dialog: {

  },
  dialogbody: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  dialoggroupname: {
    fontSize: '45px',
    fontFamily: 'League Gothic',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: '#7F1431',
  },
  dialoggroupdesc: {
    margin: '10px 0 20px',
    fontFamily: 'Roboto',
    fontSize: '14px',
    textAlign: 'center',
    maxWidth: '500px',
  },
  dialoggroups: {
    display: 'flex',
    justifyContent: 'space-evenly',
  },
  dialoggroup: {
    textAlign: 'center',
    margin: '0 20px',
    '& column': {
      border: '1px solid lightgray',
    },
  },
  closerow: {
    textAlign: 'right',
    height: '5px',
  },
  close: {
    cursor: 'pointer',
  },
  img_close: {
    width: '30px',
    '&:hover': {
      width: '22px',
      transition: 'all 0.15s ease',
    },
  },
  flag: {
    cursor: 'pointer',
  },
  flagImg: {
    height: '65px',
    width: '65px',
  },
  rank: {
    fontSize: '14px',
    fontFamily: 'Roboto',
  },
  dialogteamname: {
    textTransform: 'uppercase',
    fontSize: '20px',
    margin: '5px 0',
    textAlign: 'center',
    cursor: 'pointer',
    fontFamily: 'Roboto',
  },
  columnscontainer: {
    display: 'flex',
    justifyContent: 'center',
    borderBottom: '1px solid lightgray',
  },
  columns: {
    width: '20px',
    height: '120px',
    display: 'flex',
    flexDirection: 'column-reverse',
    margin: '0 10px',
  },
  columns_statsfirst: {
    backgroundColor: '#62AD1D',
    transition: 'height .6s ease',
  },
  columns_statssecond: {
    backgroundColor: '#F9981D',
    transition: 'height .6s ease',
  },
  columns_statsout: {
    backgroundColor: '#D8D8D8',
    transition: 'height .6s ease',
  },
  columns_legend_container: {
    display: 'flex',
    justifyContent: 'center',
    margin: '0 0 30px 0',
  },
  columns_legend: {
    width: '20px',
    margin: '0 10px',
  },
  smalltext: {
    fontSize: '10px',
  },
  dialogbutton: {
    borderRadius: '20px',
    border: '1px solid lightgray',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '3px',
    padding: '5px 10px',

  },
  dialogbutton_firstpicked: {
    composes: ['$dialogbutton'],
    border: '1px solid #62AD1D',
  },
  dialogbutton_secondpicked: {
    composes: ['$dialogbutton'],
    border: '1px solid #F9981D',
  },
  column: {
    borderRadius: '20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '3px',
    padding: '5px 10px',
  },
  column_firstpicked: {
    composes: ['$column'],
    border: '1px solid #62AD1D',
  },
  column_secondpicked: {
    composes: ['$column'],
    border: '1px solid #F9981D',
  },
  picked: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '20px',
    height: '20px',
    fontSize: '11px',
    borderRadius: '50%',
    textAlign: 'left',
    color: '#fff',
    marginRight: '9px',
    lineHeight: '11px',
  },
  firstpicked: {
    display: 'flex',
    justifyContent: 'center',
    // '& $picked': {
    //   backgroundColor: '#62AD1D',
    //   // boxShadow: '0 0 0 1pt #62AD1D',
    // },
    // '& $teamname': {
    //   // color: '#62AD1D',
    // },
  },
  secondpicked: {
    display: 'flex',
    justifyContent: 'center',
    // '& $picked': {
    //   backgroundColor: '#F9981D',
    //   // boxShadow: '0 0 0 1pt #F9981D',
    // },
    // '& $teamname': {
    //   // color: '#F9981D',
    // },
  },
  nopicked: {
    display: 'flex',
    // alignItems: 'center',
    textAlign: 'left',
    justifyContent: 'center',
    // border: '1px solid pink',
    // padding: '3px',
    // backgroundColor: 'aquamarine',
    // transition: 'all 0.5s ease-in-out',
    // background: `url(assets/flags/${team.id}.svg)`,
  },
  teamname: {
    width: '96px',

    fontFamily: 'Roboto',
    // fontWeight: '600',

  },
  bars: {
    width: '100%',
    padding: '6px 0 7px',
    marginLeft: '5px',
    borderLeft: '1px solid #E9E9E9',
    minWidth: '24px',
    cursor: 'pointer',
  },
  bar: {
    height: '4px',
  },
  bar_back: {
    composes: ['$bar'],
    backgroundColor: '#D8D8D8',
  },
  bar_stats: {
    composes: ['$bar'],
    backgroundColor: '#3C989E',
    transition: 'width .6s ease',
  },

  nonpick: {
    display: 'block',
    width: '20px',
    height: '20px',
    border: '1px solid lightgray',
    borderRadius: '10px',
    marginRight: '9px',
    // marginTop: '1px',
    cursor: 'pointer',
  },
  // picked: {
  //   display: 'flex',
  //   justifyContent: 'center',
  //   alignItems: 'center',
  //   width: '20px',
  //   height: '20px',
  //   fontSize: '11px',
  //   borderRadius: '50%',
  //   border: '1px solid lightgray',
  //   textAlign: 'center',
  //   color: '#fff',
  //   marginRight: '9px',
  //   marginTop: '1px',
  //   lineHeight: '21px',
  // },

  footer: {
    display: 'flex',
    justifyContent: 'space-evenly',
    margin: '10px 0 20px',
    textAlign: 'left',
  },
  footerintro: {
    textAlign: 'center',
    fontFamily: 'Roboto',
    fontSize: '12px',
    margin: '10px 0 0 0',
  },
  footerdesc: {
    // maxWidth: '500px',
    margin: '0 auto 10px auto',
  },
  luidialogbody: {
    padding: '5px 15px',
  },
  bad: {
    color: 'crimson',
    textDecoration: 'line-through',
    textDecorationStyle: 'double',
  },
  modalContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'auto',
    boxShadow: 24,
    padding: '5px',
    backgroundColor: '#FFFFFF',
    height: '90%',
    overflowY: 'auto',
    maxHeight: '686px',
  },

  tablePredictionGroup: {
    marginTop: '10px',
    borderTop: '1px solid #dedede',
  },
  tablePredictionGroupHeading: {
    fontFamily: 'League Gothic',
    fontSize: '1.8em',
    color: '#7F1431',
    margin: '7px 0',
  },
  tableGroup: {
    tableLayout: 'fixed',
    width: '100%',
  },
  thTeam: {
    border: '1px solid #dedede',
    padding: '0 5px',
  },
  thTeamEmpty: {
    backrgoundColor: 'white',
    border: 'none',
  },
  tdTeam: {
    fontWeight: 'bold',
    border: '1px solid #dedede',
    padding: '0 5px',
  },
  tdCell: {
    width: '200px',
    border: '1px solid #dedede',
    padding: '0 5px',
  },
  tdCellEmpty: {
    border: '1px solid #dedede',
    backgroundColor: '#FFFFFF',
  },
  ourGroupPred: {
    margin: '10px 0',
    fontSize: '0.85em',
    color: '#7F1431',
  },
};

export default styles;
